import { action } from 'satcheljs';
import HierarchyNotificationPayload from 'owa-service/lib/contract/HierarchyNotificationPayload';

export const onCalendarNotification = action(
    'ON_CALENDAR_NOTIFICAITON',
    (notification: HierarchyNotificationPayload) => ({
        notification,
    })
);

export const initializeUpNext = action('INITIALIZE_UP_NEXT');
